import IsLoaded from "common/isLoaded";
import useLazySelector, { useLazyLoader } from "common/redux/useLazySelector";
import { Fee } from "domain/fee";
import * as MerchantActions from 'features/merchants/merchants.actions';

const defaultVal: Fee[] = [];
export default function useFees(): Fee[] {
    return useLazySelector(store => store.merchantFees, MerchantActions.loadMerchantFees, null, defaultVal);
}

export function useFeesLoader(): IsLoaded<Fee[]> {
    return useLazyLoader(store => store.merchantFees, MerchantActions.loadMerchantFees, null, defaultVal);
}